import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationsTransformationId } from "@dashboardApi/apis/dataTransformation/constants";
import type {
  GenerateTransformationRequest,
  GenerateTransformationResponse,
} from "@dashboardApi/apis/dataTransformation/types";
import fetch from "@lib/fetch";

// TODO(OPR-978): Remove this legacy AI-copilot fetcher (and the /generate backend endpoint) once
// replace_data_transformations_ai_copilot_with_operator is at 100%.
export const generateTransformation = reactQueryMutationAdapter(
  appsTransformationsTransformationId,
  async (request: GenerateTransformationRequest): Promise<GenerateTransformationResponse> => {
    return fetch(
      `/apps/transformations/${request.transformation_id}/generate`,
      "POST",
      request,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
